export const META_PIXEL_ID = '2314886982646161'

const BASE_CODE_ID = 'meta-pixel-base-code'

type FbqFn = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue?: unknown[]
}

declare global {
  interface Window {
    fbq?: FbqFn
    _fbq?: FbqFn
  }
}

/**
 * Inyecta y ejecuta el Meta Pixel base code EXACTAMENTE como el snippet oficial,
 * incluyendo fbq('init', '2314886982646161') y fbq('track', 'PageView').
 * Se llama desde index.tsx antes de montar React, por lo que corre en cada carga
 * de la página publicada (protocolo.thesolismethod.com), no solo en el editor.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.fbq || document.getElementById(BASE_CODE_ID)) return

  const script = document.createElement('script')
  script.id = BASE_CODE_ID
  script.text = [
    "!function(f,b,e,v,n,t,s)",
    "{if(f.fbq)return;n=f.fbq=function(){n.callMethod?",
    "n.callMethod.apply(n,arguments):n.queue.push(arguments)};",
    "if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';",
    "n.queue=[];t=b.createElement(e);t.async=!0;",
    "t.src=v;s=b.getElementsByTagName(e)[0];",
    "s.parentNode.insertBefore(t,s)}(window, document,'script',",
    "'https://connect.facebook.net/en_US/fbevents.js');",
    `fbq('init', '${META_PIXEL_ID}');`,
    "fbq('track', 'PageView');",
  ].join('\n')

  document.head.appendChild(script)
}

/** PageView adicional para las navegaciones internas del funnel (SPA). */
export function trackPageView(): void {
  initMetaPixel()
  window.fbq?.('track', 'PageView')
}

export function trackAddToCart(payload: {
  content_name: string
  content_ids: string[]
  value: number
  currency?: string
}): void {
  initMetaPixel()
  window.fbq?.('track', 'AddToCart', {
    content_type: 'product',
    currency: 'USD',
    ...payload,
  })
}

/** True cuando fbevents.js ya cargó y los eventos se envían de verdad. */
export function isPixelLoaded(): boolean {
  return typeof window !== 'undefined' && Boolean(window.fbq?.callMethod)
}
